import { Modal, Button, Space } from 'antd'
import { useTranslation } from 'react-i18next'

interface ConfirmDialogProps {
  open: boolean
  title?: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  variant?: 'danger' | 'default'
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  variant = 'default',
  loading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const { t } = useTranslation()
  const resolvedTitle = title ?? t('confirm')
  const resolvedConfirm = confirmLabel ?? t('confirm')
  const resolvedCancel = cancelLabel ?? t('cancel')

  return (
    <Modal
      open={open}
      title={resolvedTitle}
      onCancel={onCancel}
      footer={
        <Space>
          <Button onClick={onCancel} disabled={loading}>
            {resolvedCancel}
          </Button>
          <Button
            type="primary"
            danger={variant === 'danger'}
            loading={loading}
            onClick={onConfirm}
          >
            {resolvedConfirm}
          </Button>
        </Space>
      }
      destroyOnHidden
    >
      <p className="whitespace-pre-wrap">{message}</p>
    </Modal>
  )
}
